import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';

import postsFunctionalContent from './admin-posts-functional-content';
import themesFunctionalContent from './admin-themes-functional-content';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

const bemClassesAdminPane = new Bem('adminPanelForum');

/**
 * === AdminPanel Component ===
 * Рендерит админ панель для управления выбранными постами/темами
 *
 * = Example =
 * <AdminPanel
 *   selectedItems={selectedPosts}
 *   onHandleDelete={this.onHandleDeletePost}
 *   onResetSelection={this.onHandleSelect}
 *   entity={entity}
 * />
 */

export default class AdminPanel extends PureComponent {
  static propTypes = {
    className: PropTypes.string,

    // Selected posts by Admin via checkboxes
    selectedItems: PropTypes.arrayOf(PropTypes.shape({})),

    // Delete posts method
    onHandleDelete: PropTypes.func.isRequired,

    // Remove items from state
    onResetSelection: PropTypes.func,

    // Which entity content should be rendered
    entity: PropTypes.oneOf(['themes', 'posts']).isRequired
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.entities = {
      posts: postsFunctionalContent.bind(this),
      themes: themesFunctionalContent.bind(this)
    };
  }

  render() {
    const { className, selectedItems, entity } = this.props;
    const cfgContent = this.entities[entity];
    const itemsExist = selectedItems && !!selectedItems.length;

    return (
      <div {...bemClassesAdminPane(null, { appear: itemsExist }, { extra: className })}>
        <div {...bemClassesAdminPane('content')}>
          <div {...bemClassesAdminPane('noted')}>
            <span {...bemClassesAdminPane('text')} children="Выбрано" />
            <span
              {...bemClassesAdminPane('text', 'second')}
              children={selectedItems ? selectedItems.length : 0}
            />
          </div>
          <div
            {...bemClassesAdminPane('items')}
            children={cfgContent && itemsExist && cfgContent(bemClassesAdminPane)}
          />
        </div>
      </div>
    );
  }
}
